import type { UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from 'shared/store/serverSide/EQueryKeys';

export type QueryError = UnknownError;

export type QueryKey = [EQueryKeys.Yandex__ApiMaps_2_1, string];
export const getQueryKey = (query: QueryKey[1]): QueryKey => [EQueryKeys.Yandex__ApiMaps_2_1, query];
